import {
 ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import clinicalCarePriorities from '@/services/api/clinicalCarePriorities'
import React, { useCallback } from 'react'
import FormPriority from './components/Form'
import Row from './components/Row'

// import { Container } from './styles';

function Priorities({ title }) {
  usePageTitle({ title })
  const query = useQuery()

  const {
    loading, data, error, fetchData, setData,
  } = useAxiosRequest(clinicalCarePriorities.list, query)

  const onPriorityRemoved = useCallback((priority) => {
    setData((oldData) => ({
      ...oldData,
      rows: oldData.rows.filter((p) => p.id !== priority.id),
      count: oldData.count - 1,
    }))
  }, [setData])

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Prioridades de atendimentos clínicos"
        icon="fas fa-exclamation"
        subtitle="Listagem dos níveis de prioridades que podem ser atribuídos aos atendimentos clínicos."
        rightAction={() => (
          <FormPriority btnClass="btn btn-primary" btnIcon="fas fa-plus" btnText="Adicionar" onApiResponse={fetchData} />
        )}
      />
      <ListManager loading={loading} count={data?.count || 0} error={error}>
        {
          Boolean(data) && (
            <div>
              <small>
                <table className="table">
                  <thead>
                    <tr>
                      <th width="1`">Cor</th>
                      <th>Prioridade</th>
                      <th>Nível</th>
                      <th className="text-right" width="80px">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.rows.map((priority) => (
                        <Row
                          key={priority.id}
                          priority={priority}
                          fetchData={fetchData}
                          onPriorityRemoved={onPriorityRemoved}
                        />
                      ))
                    }
                  </tbody>
                </table>
              </small>
              {
                Boolean(data) && (
                  <div className="my-2">
                    <Paginator paginatedList={data} />
                  </div>
                )
              }
            </div>
          )
        }
      </ListManager>
    </Styles.Container>
  )
}

export default Priorities
